import React from "react";
export default function ExploreGenres({ Genre, backdropImage }) {

    let back;
    { backdropImage.map((v, i) => back = v.backdrop_path) }

    let listSlice = backdropImage.slice(0, 19)
    return (
        <div className="text-white px-4 lg:px-10 pt-32">
            <h1 className="text-3xl font-bold">Explore Genres</h1>
            <p>See Wide Range of genres you like</p>

            <div className="relative ">
                <div className="z-50  px-4  my-6 ">
                    <div className="flex overflow-auto gap-3 [&::-webkit-scrollbar]:h-1
                    [&::-webkit-scrollbar-track]:rounded-full
                    [&::-webkit-scrollbar-track]:bg-gray-100
                    [&::-webkit-scrollbar-thumb]:rounded-full 
                    [&::-webkit-scrollbar-thumb]:bg-gray-300
                    dark:[&::-webkit-scrollbar-track]:bg-[#7300FF10]
                    dark:[&::-webkit-scrollbar-thumb]:bg-[#7300FF] pb-4">
                        {
                            listSlice?.map((v, i) =>
                                <div key={i} className="flex-shrink-0 relative" >
                                    <div className="group border-[#7300FF] hover:border-[1px] rounded-xl  w-fit">
                                        <img src={v.backdrop_path ? `https://image.tmdb.org/t/p/w300/${v.backdrop_path}` : '/posternotFound.jpg'} className="w-[200px] h-[114px] rounded-xl brightness-50 " />
                                        <p className="absolute top-0  w-[200px] flex justify-center items-center h-[114px] font-bold text-xl  rounded-xl group-hover:bg-[#7300FF30] ">
                                            <span >
                                                {Genre[i] !== undefined ? Genre[i].name : ''}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                    </div>

                </div>
            </div>
        </div>
    )
}